<template>
  <qx-card title="公司资料">
    <section>
      <!-- 订单详情数据 -->
      <qx-detail-box :data="detailData.base"></qx-detail-box>
    </section>
    <!-- 订单详情数据 end -->
  </qx-card>
</template>

<script>
import {
  fleetDetail, // 获取详情
} from 'api/getPay';
import {
  getFileUrl,
} from 'api';
export default {
  data () {
    return {
      getDetailLoading: false,
      detailData: {
        base: {
          label: '车队信息',
          tableData: {
            title: [
              // {
              //   prop: 'linkPhone',
              //   label: '手机号码',
              // },
              // {
              //   prop: 'linkMan',
              //   label: '超管姓名',
              // },
              // {
              //   prop: 'linkManIdentification',
              //   label: '超管身份证',
              // },
              {
                prop: 'businessLicense',
                label: '营业执照',
                type: 'img',
              },
              {
                prop: 'companyQualifications',
                label: '企业资质',
                type: 'img',
              },
              {
                prop: 'companyName',
                label: '企业全称',
              },
              {
                prop: 'shortName',
                label: '企业简称',
              },
              {
                prop: 'companyAddress',
                label: '企业注册地址',
              },
              {
                prop: 'businessLicenseNo',
                label: '社会信用代码',
              },
              {
                prop: 'address',
                label: '常用办公地点',
              },
              {
                prop: 'logo',
                label: '车队LOGO',
                type: 'img',
              },
            ],
            data: {
            },
            approveData: {
            },
          },
        },
      },
    };
  },
  computed: {
    colSpan () {
      const total = 24;
      const minSpan = 4;
      return parseInt(total / this.orderInfo.length, 10) < minSpan ? minSpan : parseInt(total / this.orderInfo.length, 10);
    },
    newDetailInfo () {
      let detailData = JSON.parse(JSON.stringify(this.detailData));
      return this.hideSensitiveInfo ? (detailData.base.tableData.title = [{
        prop: 'linkPhone',
        label: '手机号码',
      }]) : detailData;
    },
    detailDataHideSensitiveInfo () {
      let detailData = JSON.parse(JSON.stringify(this.detailData));
      if (this.hideSensitiveInfo) {
        let newTitle = [];
        for (let item of detailData.base.tableData.title) {
          if (item.prop === 'linkPhone') {
            newTitle.push(item);
          }
        }
        detailData.base.tableData.title = newTitle;
        return detailData;
      } else {
        return detailData;
      }
    },
  },
  watch: {
    '$route.query.id': function () {
      if (this.$route.path === '/manage/other/fleet/base') {
        this.getData();
      }
    },
  },
  methods: {
    async getData () {
      this.getDetailLoading = true;
      const detailRes = await fleetDetail({
        tenantId: this.$route.query.id,
        showMoney: true,
      });
      const urlRes = await getFileUrl({
        flowIds: `${detailRes.tenantInfo.businessLicense},${detailRes.tenantInfo.companyQualifications},${detailRes.tenantInfo.logo},${detailRes.tenantInfo.identificationPicture}`,
        _GRID_TYPE: 'jq',
      });

      if (urlRes.rows && urlRes.rows.length) {
        if (urlRes.rows[0]) {
          detailRes.tenantInfo.businessLicense = urlRes.rows[0].fullPath;
        }
        if (urlRes.rows[1]) {
          detailRes.tenantInfo.companyQualifications = urlRes.rows[1].fullPath;
        }
        if (urlRes.rows[2]) {
          detailRes.tenantInfo.logo = urlRes.rows[2].fullPath;
        }
        if (urlRes.rows[3]) {
          detailRes.tenantInfo.identificationPicture = urlRes.rows[3].fullPath;
        }
      }

      this.getDetailLoading = false;
      if (!detailRes.failed) {
        this.detailData.base.tableData.data = detailRes.tenantInfo;
      }
    },
  },
  async created () {
    this.getData();
  },
};
</script>
